import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
import { Emission } from "./emissions";

const supply_chain = apiUrl + "/supply_chain";
const routes = {
  label: "Supply Chain",
  root: supply_chain,
  new: supply_chain + "/new",
  delete: supply_chain + "/delete",
  update: supply_chain + "/update",
  duplicate: supply_chain + "/duplicate",
  archive: supply_chain + "/archive",
  unarchive: supply_chain + "/unarchive",
  add_from_supplier_report: supply_chain + "/add_from_supplier_report",
  get_mine: supply_chain + "/get_mine",
  get_from_my_workspace: supply_chain + "/get_from_my_workspace",
  get_total_gwp_by_scope: supply_chain + "/get_total_gwp_by_scope",
  generate_insight_5_0: supply_chain + "/generate_insight_5_0",
  generate_insight_3_5: supply_chain + "/generate_insight_3_5",
  generate_insight_deepseek: supply_chain + "/generate_insight_deepseek",
  generate_insight_gemini_flash: supply_chain + "/generate_insight_gemini_flash",
  generate_insight_gemini_flash_lite: supply_chain + "/generate_insight_gemini_flash_lite",
  generate_insight_gemini_pro: supply_chain + "/generate_insight_gemini_pro",
  get_insight: supply_chain + "/get_insight",
  get_actionable_insight: supply_chain + "/get_actionable_insight",
  generate_actionable_insight: supply_chain + "/generate_actionable_insight",
};
export const Supply_chain = {
  label: routes.label,
  new: (data) => postWithToken(routes.new, data),
  update: (body) => postWithToken(routes.update, body),
  duplicate: (ids) => postWithToken(routes.duplicate, { ids }),
  archive: (ids) => postWithToken(routes.archive, { ids }),
  unarchive: (ids) => postWithToken(routes.unarchive, { ids }),
  delete: (ids) => postWithToken(routes.delete, { ids }),
  add_from_supplier_report: (ids) => postWithToken(routes.add_from_supplier_report, { ids }),
  get_total_gwp_by_scope: (ids) => getWithToken(routes.get_total_gwp_by_scope, { ids }),
  get_mine: () => getWithToken(routes.get_mine),
  get_from_my_workspace: () => getWithToken(routes.get_from_my_workspace),
  getEmissions: (id) => Emission.getEmissionsBySupplyChainId({ id }),
  get_insight: (id) => getWithToken(routes.get_insight, { id }),
  get_actionable_insight: (id) => getWithToken(routes.get_actionable_insight, { id }),
  generate_actionable_insight: (id) => postWithToken(routes.generate_actionable_insight, { id }),
  generate_insight_5_0: (id) => postWithToken(routes.generate_insight_5_0, { id }),
  generate_insight_3_5: (id) => postWithToken(routes.generate_insight_3_5, { id }),
  generate_insight_deepseek: (id) => postWithToken(routes.generate_insight_deepseek, { id }),
  generate_insight_gemini_flash: (id) => postWithToken(routes.generate_insight_gemini_flash, { id }),
  generate_insight_gemini_flash_lite: (id) => postWithToken(routes.generate_insight_gemini_flash_lite, { id }),
  generate_insight_gemini_pro: (id) => postWithToken(routes.generate_insight_gemini_pro, { id }),
  request_validation: (ids) => postWithToken(supply_chain + "/request_validation", { ids }),
  set_validation_status: (payload) => postWithToken(supply_chain + "/set_validation_status", payload),
  retrieve: (ids) => postWithToken(supply_chain + "/retrieve", { ids }),
};

